import { router } from '@/app/app-router';
import { store } from '@/app/app-store';
import App from '@/app/app.vue';
import '@/app/shared';
import { oidcSettings } from '@/app/shared/config';
import { oidcMiddleware } from '@/app/shared/middlewares';
import '@/main.scss';
import '@/mocks/server';
import '@/plugins';
import { i18n, vuetify } from '@/plugins';
import Oidc from '@sone/sone-frontend-core/src/plugins/oidc';
import Vue from 'vue';
import VueHead from 'vue-head';
import Toast, { POSITION } from 'vue-toastification';
import VuetifyMask from 'vuetify-mask';
import EventBus from 'vue-bus-ts';
import VuetifyMoney from 'vuetify-money';

Vue.use(VueHead);
Vue.use(VuetifyMask);
Vue.use(VuetifyMoney);
Vue.use(Oidc, { router, oidcSettings, store, middleware: oidcMiddleware });
Vue.use(Toast, { position: POSITION.BOTTOM_RIGHT });
Vue.use(EventBus);
const bus = new EventBus.Bus();

Vue.config.productionTip = false;

new Vue({
  router,
  bus,
  store,
  i18n,
  vuetify,
  render: (h: Function) => h(App),
}).$mount('#app');
